module.exports = __webpack_public_path__ + "img/play.ee94a745.svg";